import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { ISubmissionPublicationPagedRequest } from '../../../../model/sep/submission-publications/request/submissin-publication-paged-request';
import LinearProgress from '@mui/material/LinearProgress';
import Chip from '@mui/material/Chip';
import moment from 'moment';
import { Pagination } from '../../../../model/pagination';
import { IOfficialDiaryPagedRequest } from '../../../../model/sdp/official-daily/request/official-diary-paged-request';
import OfficialDiaryAppService from '../../../../application/platform/sdp/official-diary/official-diary-app-service';
import { IOfficialDiaryPagedResponse } from '../../../../model/sdp/official-daily/response/official-diary-paged-response';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import { IconButton, ListItemIcon, ListItemText } from '@mui/material';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SettingsIcon from '@mui/icons-material/Settings';
import { DefaultDialogProps } from '../../../../components/default-dialog';
import { useBaseLayout } from '../../../../components/context/use-base-layout';
import { dataGridLocaleConfig } from '../../../../config/data-grid-locale';

export interface IOfficialDiaryDataTableProps {
    parameters: IOfficialDiaryPagedRequest
};
interface IOfficialDiaryDataTableMenuContextProps {
    parameters: IOfficialDiaryPagedRequest
    isVisibility: boolean;
    officialDailyId: number;
    isClosed: boolean;
    loadData: () => void;
};
function MenuPopupState({ props }: { props: IOfficialDiaryDataTableMenuContextProps }) {
    const { showDialog, showLoading } = useBaseLayout();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const changeVisibility = () => {
        handleClose();
        (async () => {
            showDialog({
                open: true,
                message: `Deseja realmente tornar essa Edição do Diário ${props.isVisibility ? 'invisível' : 'vísível'}?`,
                onYesClick: () => {
                    (async () => {
                        showLoading({ open: true });
                        await OfficialDiaryAppService.changeVisibility(props.officialDailyId);
                        showLoading({ open: false });
                        props.loadData();
                    })();
                }

            } as DefaultDialogProps);

        })();

    }
    const closeOfficialDaily = () => {
        handleClose();
        (async () => {
            showDialog({
                open: true,
                message: `Deseja realmente fechar essa Edição do Diário?`,
                onYesClick: () => {
                    (async () => {
                        showLoading({ open: true });
                        await OfficialDiaryAppService.close(props.officialDailyId);
                        showLoading({ open: false });
                        props.loadData();
                    })();
                },
            } as DefaultDialogProps);

        })();
    }
    const gotToDetails = () => {
        handleClose();
        navigate(`/diario-oficial/detalhes/${props.officialDailyId}`);

    }

    let itemMenuClosed = undefined;

    if (!props.isClosed) {
        itemMenuClosed = <MenuItem onClick={closeOfficialDaily}>
            <ListItemIcon>
                <DoDisturbIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Fechar Edição</ListItemText>
        </MenuItem>;
    } 


    return (


        <div>
            <IconButton
             color="primary" 
                // variant="contained"
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}>
                    <SettingsIcon />
            </IconButton>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={gotToDetails}>
                    <ListItemIcon>
                        <DisplaySettingsIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Detalhes</ListItemText>
                </MenuItem>
                <MenuItem onClick={changeVisibility}>
                    <ListItemIcon>
                        {props.isVisibility ? (
                            <VisibilityOffIcon fontSize="small" />
                        ) : (
                            <VisibilityIcon fontSize="small" />
                        )}
                    </ListItemIcon>
                    <ListItemText>{props.isVisibility ? 'Tornar Invisível' : 'Tornar Visível'}</ListItemText>
                </MenuItem>
                {itemMenuClosed}

            </Menu>
        </div>
    );
}

export default function OfficialDiaryDataTable({ props }: { props: IOfficialDiaryDataTableProps }) {
    const [response, setResponse] = useState<Pagination<IOfficialDiaryPagedResponse>>(new Pagination<IOfficialDiaryPagedResponse>);
    const [submissionPublicationDataTableProps, setSubmissionPublicationDataTableProps] = useState<IOfficialDiaryDataTableProps>(props);
    const [loadMoreData, setLoadMoreData] = useState(true);

    const reloadData = () => {
        console.log("chamou");
        loadData(submissionPublicationDataTableProps.parameters);
    }
    const loadData = (parameters: ISubmissionPublicationPagedRequest) => {
        (async () => {
            if (parameters !== undefined) {
                setLoadMoreData(true);
                const data = await OfficialDiaryAppService.get(parameters);
                setResponse(data);
                setLoadMoreData(false);
            }
        })();
    }

    const columns: GridColDef<IOfficialDiaryPagedResponse>[] = [
        { field: 'id', headerName: 'Id', width: 90, hide: true },
        {
            field: 'editionNumber',
            headerName: 'Nº Edição/Ano',
            flex: 1,
            renderCell: (params) => {
                return params.row.editionNumber + '/' + params.row.yearPublication
            }
        },
        {
            field: 'publicationDate',
            headerName: 'Publicada em',
            flex: 1,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        {
            field: 'description',
            headerName: 'Descrição',
            flex: 3
        },
        {
            field: 'clientName',
            headerName: 'Entidade',
            flex: 3
        },
        {
            field: 'closedOn',
            headerName: 'Fechada em',
            flex: 1,
            valueFormatter: params => params?.value !== undefined && params?.value !== null ? moment(params?.value).format("DD/MM/YYYY") : null,
        },
        {
            field: 'isClosed',
            headerName: 'Fechada',
            width: 90, align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                let chip = <Chip label={"NÃO"} color="error" />
                if (params.row.isClosed) {
                    chip = <Chip label={"SIM"} color="success" />
                }
                return chip;
            }
        },
        {
            field: 'isVisibility',
            headerName: 'Visível',
            width: 90,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                let chip = <Chip label={"NÃO"} color="error" />
                if (params.row.isVisibility) {
                    chip = <Chip label={"SIM"} color="success" />
                }
                return chip;
            }
        },
        {
            field: "action",
            headerName: "",
            sortable: false,
            width: 160,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                return (
                    <MenuPopupState props={{ isClosed: params.row.isClosed, isVisibility: params.row.isVisibility, officialDailyId: params.row.id, parameters: props.parameters, loadData: reloadData }}></MenuPopupState>

                );
            }
        }
    ];

    useEffect(() => {
        loadData(props.parameters);
        setSubmissionPublicationDataTableProps(props);
    }, [props]);

    useEffect(() => {
        loadData(submissionPublicationDataTableProps.parameters);
    }, [submissionPublicationDataTableProps.parameters]);


    return (<React.Fragment>

        <DataGrid
            rows={response.items}
            columns={columns}
            page={submissionPublicationDataTableProps?.parameters.page}
            pageSize={response.pageSize}
            disableSelectionOnClick
            onPageChange={(newPage) => {
                setSubmissionPublicationDataTableProps({ ...submissionPublicationDataTableProps, parameters: { ...submissionPublicationDataTableProps.parameters, page: newPage } });
            }}
            paginationMode="server"
            components={{
                LoadingOverlay: LinearProgress,
            }}
            loading={loadMoreData}
            rowsPerPageOptions={[response.pageSize]}
            experimentalFeatures={{ newEditingApi: true }}
            localeText={dataGridLocaleConfig}
        />
    </React.Fragment>
    )
}